import React from 'react';
import {withStyles} from '@material-ui/core';
import LinkIconButton from './LinkIconButton';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import iconNames from './IconNames';

const cleanPhone = (phone) => {
    let num = phone.match(/[\d\\+]+/g);
    return num ? num.join('').replace('+', '00') : '';
};

const PhoneLinkButton = ({phone, text, href, icon, iconOnly, tooltipProps, iconButtonProps, iconProps, target, ...props}) => {
    return iconOnly ? (
        <Tooltip placement="bottom-start" title={phone} {...tooltipProps}>
            <IconButton href={href || `tel:${cleanPhone(phone || text)}`} {...iconButtonProps}>
                <Icon {...iconProps}>{icon || iconNames.phone}</Icon>
            </IconButton>
        </Tooltip>
    ) : (
        <LinkIconButton
            iconOnly={iconOnly}
            text={text || phone}
            href={href || `tel:${cleanPhone(phone || text)}`}
            icon={icon || iconNames.phone}
            target={target}
            {...props}
        />
    );
};

const styles = theme => ({});

export default withStyles(styles)(PhoneLinkButton);


